<template>
  <div id="nodata">
    <!-- 暂无数据 -->
    <div class="nodata" v-if="ishow">
      <el-empty description="暂无数据~"></el-empty>
      <!-- <el-image :src="pubImg + '/ndata.png'" class="img1"></el-image>
      <p>暂无数据~</p> -->
    </div>
    <!-- 暂无数据 -->
  </div>
</template>

<script>
  export default {
    name: 'nodata',
    data() {
      return {
        pubImg: localStorage.getItem("pubImg"), //图片路径
      }
    },

    props: {
      ishow: Boolean, //是否显示案例
    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/noData.vue